/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import closeIcon from '../../assets/images/closeIcon.svg';

import validateEmail from '../../helpers/validateEmail';

import classes from './styles.module.scss';
import MeetingService from '../../services/MeetingService';
import ConfirmButton from '../../components/Buttons/ConfirmButton';
import RoundedInput from '../../components/Inputs/RoundedInput';
import Textarea from '../../components/Textarea';
import EmojiPickerWithButton from '../../components/EmojiPickerWithButton';

export default function AssignSectionModal({
  show,
  handleClose,
  meetingId,
  refetchSections,
  setIsAssignSectionPopupVisible,
  setAssignSectionErrorMessage,
  setIsAssignSectionSuccessPopupVisible,
  hidePlaceholder,
  onSectionAssigned, // Optional callback for draft mode (adds to Redux only)
}) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEmailValidated, setIsEmailValidated] = useState(false);

  const resetForm = (isSectionAssigned = false) => {
    handleClose();
    setIsSubmitted(false);
    setEmail('');
    setMessage('');

    if (!isSectionAssigned) {
      hidePlaceholder();
    }
  };

  const submitForm = async () => {
    try {
      // If onSectionAssigned callback is provided, use it (draft mode - no backend call)
      if (onSectionAssigned) {
        onSectionAssigned({ email, message });
        setIsSubmitted(true);
        resetForm(true);
        // Show success message via AlertModal
        if (setIsAssignSectionSuccessPopupVisible) {
          setIsAssignSectionSuccessPopupVisible(true);
        }
        return;
      }

      // Otherwise, use the old flow (published meetings - immediate backend call)
      const id = meetingId;

      await MeetingService.assignSection({
        meetingId: id,
        email,
        message,
      });

      await refetchSections();
      setIsSubmitted(true);
      resetForm(true);
      // Show success message via AlertModal
      if (setIsAssignSectionSuccessPopupVisible) {
        setIsAssignSectionSuccessPopupVisible(true);
      }
    } catch (error) {
      console.error(error);
      setAssignSectionErrorMessage(
        error?.response?.data?.message || 'Something went wrong'
      );
      setIsAssignSectionPopupVisible(true);
      handleClose();
    }
  };

  const emailChangedHandler = (event) => {
    setEmail(event.target.value);
  };

  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.AssignSectionModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
    >
      {isSubmitted && (
        <div className={classes.successOverlay}>
          <div className={classes.popup}>
            <i className={classes.closeIcon} onClick={handleClose}>
              <img src={closeIcon} alt="Close" />
            </i>
            <b>{onSectionAssigned ? 'Section Added to Draft' : 'Section Assigned!'}</b>
            <span>
              {onSectionAssigned
                ? 'The section will be assigned when you save the draft. You will be notified when the collaborator completes the section(s).'
                : 'You will be notified when collaborator completes section(s)'}
            </span>
          </div>
        </div>
      )}
      <i
        className={classes.closeIcon}
        onClick={() => {
          handleClose();
          resetForm();
        }}
      >
        <img src={closeIcon} alt="Close" />
      </i>
      <div className={classes.form}>
        <h1>Invite other users to create content for your video</h1>
        <RoundedInput
          placeholder="Add email address"
          type="email"
          value={email}
          onChange={emailChangedHandler}
          setValue={setEmail}
          users
          requireSuggestionSelection
          onValidationChange={setIsEmailValidated}
        />
        <div className={classes.messageContainer}>
          <Textarea
            placeholder="Add message..."
            value={message}
            onChange={(event) => setMessage(event.target.value)}
          />

          <EmojiPickerWithButton
            setCommentText={setMessage}
            buttonBottom="24px"
            buttonRight="24px"
            pickerTop="52px"
          />
        </div>

        <footer className={classes.footer}>
          <ConfirmButton
            isDisabled={!email.length || !validateEmail(email) || !isEmailValidated}
            onClick={submitForm}
          />
        </footer>
      </div>
    </Modal>
  );
}
